// Utility functions for API logic

export function getApiConfig(endpoint, params = {}) {
  const config = {
    url: endpoint.url,
    method: endpoint.method,
  };
  if (endpoint.method.toLowerCase() === 'get') {
    config.params = params;
  } else {
    config.data = params;
  }
  return config;
}

export function formatApiError(error) {
  if (!error) return '';
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  return error.message || 'Unknown error';
}
